/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Recentdeliveries_Failedtoload3Inputs */

const he_extension_popup_recentdeliveries_failedtoload3 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Failedtoload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה בטעינה`)
};

const en_extension_popup_recentdeliveries_failedtoload3 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Failedtoload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load`)
};

/**
* | output |
* | --- |
* | "Failed to load" |
*
* @param {Extension_Popup_Recentdeliveries_Failedtoload3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_recentdeliveries_failedtoload3 = /** @type {((inputs?: Extension_Popup_Recentdeliveries_Failedtoload3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Recentdeliveries_Failedtoload3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_recentdeliveries_failedtoload3(inputs)
	return en_extension_popup_recentdeliveries_failedtoload3(inputs)
});
export { extension_popup_recentdeliveries_failedtoload3 as "extension_popup_recentDeliveries_failedToLoad" }